// src/private/src/pages/app/clients/components/BackendDataBanner.jsx
import React, { memo } from 'react';
import { Alert, AlertTitle, Box, Button, Stack } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

/**
 * CTA banner shown when a client has no backend data connected.
 * Encourages them to upload CRM data to unlock full funnel tracking.
 */
function BackendDataBanner({ onDismiss }) {
  return (
    <Alert
      severity="info"
      variant="outlined"
      sx={{
        borderRadius: 2,
        mb: 2,
        '& .MuiAlert-icon': { alignItems: 'center' },
      }}
      action={
        onDismiss && (
          <Button color="inherit" size="small" onClick={onDismiss}>
            Dismiss
          </Button>
        )
      }
    >
      <AlertTitle sx={{ fontWeight: 700 }}>Unlock full funnel tracking</AlertTitle>
      <Stack spacing={1}>
        <Box>
          Connect your CRM or backend data to see set rates, issue rates, demo rates,
          close rates, revenue, and cost of marketing. Without backend data, only spend
          and lead metrics are available.
        </Box>
        <Box>
          <Button
            size="small"
            variant="contained"
            startIcon={<UploadFileIcon />}
            sx={{ textTransform: 'none', fontWeight: 600 }}
            href="/clients/onboarding"
          >
            Set up data connection
          </Button>
        </Box>
      </Stack>
    </Alert>
  );
}

export default memo(BackendDataBanner);
